import { TERME_PAIEMENT_AVANCE, ANNEE } from '@/configuration/baux/contrat/contratConf';

export default function genererEcheancierContrat() {
  return {
    dateDebut: null,
    dateFin: null,
    finPremiereEcheance: null,
    termePaiement: TERME_PAIEMENT_AVANCE,
    quantitePeriodicite: 1,
    periodiciteEcheancier: ANNEE,
    montantAnnuelHt: 0,
    pourcentageTva: 0,
    modeReglementId: null,
    tiersRepartitions: [],
  };
}
